module.exports = __webpack_public_path__ + "images/asset8.png";